export enum SetupTypeEnum {
  ExampleSetup = 'ExampleSetup',
  AtHomeSetup = 'AtHomeSetup',
  AutomationSetup = 'AutomationSetup',
  SanitaryInstallationSetup = 'SanitaryInstallationSetup',
  HeatingInstallationSetup = 'HeatingInstallationSetup',
  ReguardSetup = 'ReguardSetup',
  ResourceSetup = 'ResourceSetup',
}
